var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "button-bar", staticStyle: { "min-height": "25px" } },
    [
      (!_vm.activeQuestion && !_vm.reviewMode) || _vm.timeLimitExceeded
        ? _c(
            "button",
            {
              staticClass: "btn btn-light-blue",
              on: {
                click: function($event) {
                  return _vm.doSubmitTest()
                }
              }
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: "arrow-alt-circle-up" }
              }),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.testButtons.takeTester_submitTest")
                  ) +
                  "\n    \n    "
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.timeLimitExceeded &&
      _vm.activeQuestion &&
      !_vm.reviewMode &&
      !_vm.isGraded(_vm.activeQuestion)
        ? _c(
            "button",
            {
              staticClass: "btn btn-violet",
              attrs: { "aria-label": "Flag Question" },
              on: {
                click: function($event) {
                  return _vm.toggleQuestionFlag()
                }
              }
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: "flag", "aria-hidden": "true" }
              }),
              _c("span", { staticClass: "hidden-xs" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$t("MAIN_CONTENT.testButtons.takeTester_flagQuestion")
                    )
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isGraded(_vm.activeQuestion) &&
      !_vm.timeLimitExceeded &&
      _vm.activeQuestion &&
      !_vm.reviewMode &&
      _vm.testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK
        ? _c(
            "button",
            {
              staticClass: "btn ",
              class: _vm.getButtonClass("save"),
              attrs: {
                "aria-label": "Save Answer",
                disabled: !_vm.getCanChangeAnswer()
              },
              on: {
                click: function($event) {
                  return _vm.saveAnswer()
                }
              }
            },
            [
              _c("font-awesome-icon", {
                attrs: { icon: "save", "aria-hidden": "true" }
              }),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.testButtons.takeTester_saveAnswer")
                  ) +
                  "\n    "
              )
            ],
            1
          )
        : !_vm.timeLimitExceeded &&
          !_vm.reviewMode &&
          _vm.testPreview.TEST.STUDENT_IMMEDIATE_FEEDBACK &&
          _vm.activeQuestion &&
          _vm.getCanChangeAnswer() &&
          ["M", "S", "N", "E"].indexOf(_vm.activeQuestion.QUESTION_TYPE) > -1
        ? _c(
            "button",
            {
              class: _vm.getButtonClass("save"),
              attrs: { "aria-label": "Change Answer" },
              on: {
                click: function($event) {
                  return _vm.changeAnswer()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("MAIN_CONTENT.testButtons.takeTester_changeAnswer")
                  ) +
                  "\n    "
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "float-right" }, [
        !_vm.timeLimitExceeded
          ? _c(
              "button",
              {
                staticClass: "btn float-left",
                class: _vm.getButtonClass("prev"),
                attrs: {
                  "aria-label": "Previous Question",
                  disabled: _vm.activeQuestionIndex == 0
                },
                on: {
                  click: function($event) {
                    return _vm.previousQuestion()
                  }
                }
              },
              [
                _c("i", {
                  staticClass: "fas fa-arrow-circle-left",
                  attrs: { "aria-hidden": "true" }
                }),
                _vm._v(" "),
                _c("span", { staticClass: "hidden-xs" }, [
                  _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.previous")))
                ])
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.timeLimitExceeded && _vm.activeQuestion
          ? _c(
              "button",
              {
                ref: "next",
                staticClass: "btn float-left",
                class: _vm.getButtonClass("next"),
                attrs: { "aria-label": "Next Question" },
                on: {
                  click: function($event) {
                    return _vm.nextQuestion()
                  }
                }
              },
              [
                _c("span", { staticClass: "hidden-xs" }, [
                  _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.commonContent.next")))
                ]),
                _vm._v(" "),
                _c("font-awesome-icon", {
                  attrs: { icon: "arrow-circle-right", "aria-hidden": "true" }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }